<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">Liste des projets</h3>
        </div>
        <div class="card-toolbar">
          <a class="btn btn-icon btn-sm btn-primary mr-1"  href="/#/projet/nouveau">
            <i class="icon-md fas fa-plus"></i>
          </a>
          <a class="btn btn-icon btn-sm btn-danger mr-1"  v-b-modal.search>
            <i class="icon-md fas fa-search"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <b-row>
          <b-col md="1">
            <select class="form-control" v-model="datatable.limitPage" @change="datatableInit">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </b-col>
        </b-row>
        <b-table responsive striped hover ref="table" :items="datatable.data" :fields="fields" @sort-changed="sortChanged" show-empty empty-text="Il n'y a aucun enregistrement à afficher">
          <template #cell(titre)="data">
            <a :href="'/#/projet/detail/'+data.item.id">{{ data.value }}</a>
          </template>
          <template #cell(type_id)="data">
            <span v-for="(id,i) in data.value" :key="i"><i v-if="i > 0">|</i> {{$store.back.getParamTitre(params.ProjetType,id)}}</span>
          </template>
          <template #cell(status_id)="data">
            {{$store.back.getParamTitre(params.ProjetStatus,data.value)}}
          </template>
          <template #cell(date_livraison)="data">
            {{data.value.mois}}/{{data.value.annee}}
          </template>
        </b-table>
        <b-pagination size="lg" align="center" v-model="datatable.currentPage" @change="changePage" :total-rows="datatable.totalRow" :per-page="datatable.limitPage" aria-controls="itemList"></b-pagination>
      </div>
    </div>
    <b-modal id="search" title="Recherche" size="xl" ref="myModalDeleteRef">
      <div class="row">
        <div class="form-group col-md-4" v-for="(field,i) in fields.filter(f => f.searchable == true)" :key="i">
          <label>{{field.label}}</label>
          <input type="text" :placeholder="'Rechercher par '+field.label" :data-column="field.key" class="form-control">
        </div>
        <div class="form-group col-md-4">
          <label>Type</label>
          <select class="form-control" data-column="type_id">
            <option value="">Tout</option>
            <option v-for="t in params.ProjetType" :value="t.id" :key="t.id">{{t.titre.fr}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label>Statut</label>
          <select class="form-control" data-column="status">
            <option value="">Tout</option>
            <option v-for="s in params.status" :value="s.id" :key="s.id">{{s.titre}}</option>
          </select>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" class="float-right" @click="searchInit">
            Recherche
          </b-button>
          <b-button variant="danger" class="float-right mr-2" @click="$refs.myModalDeleteRef.hide();">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data(){
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable:true,
          searchable:true
        },
        {
          key: 'titre',
          label: 'Titre',
          sortable:false,
          searchable:true
        },
        {
          key: 'constructeur',
          label: 'Constructeur',
          sortable:false,
          searchable:true
        },
        {
          key: 'type_id',
          label: 'Type',
          sortable:false,
          searchable:false
        },
        {
          key: 'status_id',
          label: 'Statut',
          sortable:false,
          searchable:false
        },
        {
          key: 'date_livraison',
          label: 'Date Livraison',
          sortable:true,
          searchable:false
        }
      ],
      datatable:{
        currentPage: 1,
        nextPage: 2,
        previousPage: 0,
        limitPage: 20,
        totalRow: 0,
        data: []
      },
      sort:{
        field: 'id',
        value: 'DESC'
      },
      searchQuery:null,
      params:{
        status:[],
        ProjetType:[],
        ProjetStatus:[]
      }
    };
  },
  components: {
  },
  watch: {
  },
  beforeMount() {
    let params = {
      modules: ["UserRole","ProjetType","ProjetStatus"]
    };
    this.$store.back.ajax('/magic/all', params, (res) => {
      if(res.status === true){
        this.params.status = res.data['status'];
        this.params.ProjetType = res.data['ProjetType'];
        this.params.ProjetStatus = res.data['ProjetStatus'];
      }
    });
  },
  methods: {
    datatableInit: function(){
      var the = this
      this.$store.back.ajax('/projet/liste?'+this.query,null,(res) => {
        the.datatable = res;
      });
    },
    sortChanged(e){
      this.sort = {
        field: e.sortBy,
        value: e.sortDesc === true ? "DESC" : "ASC"
      };
      this.datatable.data = [];
      this.datatableInit();
    },
    changePage(e){
      this.datatable.currentPage = e;
      this.datatableInit();
    },
    searchInit(){
      this.datatable.currentPage = 1;
      let query = {};
      let inputs  = document.querySelectorAll('[data-column]');
      inputs.forEach(elt => {
        let value  = elt.value;
        let key = elt.dataset.column;
        query[key] = value
      });
      if(Object.entries(query).length > 0){
        this.searchQuery = encodeURI(JSON.stringify(query));
      }else{
        this.searchQuery = null;
      }
      this.$refs.myModalDeleteRef.hide();
      this.datatableInit();
    },
  },
  computed: {
    query: function(){
      var sort = this.sort.field === null ? null : encodeURI(JSON.stringify(this.sort));
      return 'page='+this.datatable.currentPage+'&limit='+this.datatable.limitPage+'&sort='+sort+'&search='+this.searchQuery;
    }
  },
  mounted() {
    this.datatableInit();
  }
};
</script>
